<template>
  <lb-dialog
    :value="value"
    :heading="heading"
    width="640"
    content-class="accruals-estimate-confirm-dialog"
    :loading="loading"
    :data-testid="`${testIdPrefix}`"
    @input="$emit('input', $event)"
    @change="$emit('input', $event)"
  >
    <template #body>
      <div class="accruals-estimates-confirm-dialog">
        <p class="accruals-estimates-confirm-dialog__intro">
          {{ intro }}
        </p>
        <div class="accruals-estimates-confirm-dialog__list">
          <div
            v-for="(item, index) in items"
            :key="item.key"
            class="accruals-estimates-confirm-dialog__row"
            :data-testid="`${testIdPrefix}__row--${index}`"
          >
            <span
              class="accruals-estimates-confirm-dialog__po-tag"
              :class="{
                'accruals-estimates-confirm-dialog__po-tag--vendor': item.muted,
              }"
            >
              {{ item.label }}
            </span>
            <span class="accruals-estimates-confirm-dialog__vendor">
              {{ item.vendor }}
            </span>
            <span
              v-if="item.sourceLabel"
              class="accruals-estimates-confirm-dialog__source"
            >
              {{ item.sourceLabel }}
            </span>
            <span class="accruals-estimates-confirm-dialog__amount">
              {{ item.amount }}
            </span>
          </div>
        </div>
        <div class="accruals-estimates-confirm-dialog__note-group">
          <label
            class="accruals-estimates-confirm-dialog__note-label"
            :for="noteFieldId"
          >
            {{ noteLabel }}
          </label>
          <textarea
            :id="noteFieldId"
            :value="note"
            class="accruals-estimates-confirm-dialog__note"
            :placeholder="notePlaceholder"
            :data-testid="`${testIdPrefix}__note`"
            @input="$emit('update:note', $event.target.value)"
          />
        </div>
      </div>
    </template>
    <template #actions>
      <div class="accruals-estimates-confirm-dialog__actions">
        <base-button
          class="secondaryBtn accruals-estimates-confirm-dialog__cancel"
          :data-testid="`${testIdPrefix}__cancel-btn`"
          @click="$emit('input', false)"
        >
          {{ cancelLabel }}
        </base-button>
        <base-button
          primary
          small
          class="shadow-off primaryBtn"
          :loading="loading"
          :data-testid="`${testIdPrefix}__confirm-btn`"
          @click="$emit('confirm')"
        >
          {{ confirmLabel }}
        </base-button>
      </div>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'AccrualsEstimatesConfirmDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: '',
    },
    intro: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    note: {
      type: String,
      default: '',
    },
    noteLabel: {
      type: String,
      default: '',
    },
    notePlaceholder: {
      type: String,
      default: '',
    },
    cancelLabel: {
      type: String,
      default: 'Cancel',
    },
    confirmLabel: {
      type: String,
      default: 'Confirm',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    testIdPrefix: {
      type: String,
      default: 'accruals-estimates-confirm-dialog',
    },
  },
  computed: {
    noteFieldId() {
      return `${this.testIdPrefix}__note`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsEstimatesConfirmDialog.scss';
</style>

<style lang="scss">
.accruals-estimate-confirm-dialog {
  overflow: hidden;
  border-radius: var(--radius-sm) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);

  .v-card__title.popupHeader {
    min-height: 0;
    padding: var(--space-9) var(--space-lg) !important;
    background-color: var(--grey-white) !important;
    color: var(--color-primary-base) !important;
  }

  .v-card__title.popupHeader h5 {
    color: var(--color-primary-base) !important;
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-semibold);
    line-height: 1.45;
  }

  .v-card__title.popupHeader .v-btn {
    display: none;
  }

  .v-card__text {
    padding: var(--space-lg) !important;
    border-top: var(--border-sm) solid var(--grey-100);
  }

  .v-card__actions {
    margin: 0;
    padding: var(--space-md) var(--space-lg) !important;
    border-top: var(--border-sm) solid var(--grey-100);
  }
}
</style>
